var map = {
	"./add.svg": "3592",
	"./alarm.svg": "9a10",
	"./arrow.svg": "60ae",
	"./back-arrow.svg": "25e0",
	"./check-mark.svg": "952c",
	"./clock.svg": "ea63",
	"./close-white.svg": "c619",
	"./close.svg": "e67b",
	"./exchange.svg": "f0b3",
	"./farm.svg": "773d",
	"./home.svg": "7e04",
	"./logo.svg": "d191",
	"./percolate.svg": "f6c7",
	"./settings.svg": "1f0e",
	"./todos.svg": "3d3e",
	"./toll.svg": "16e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7906";